import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill-mention/dist/quill.mention.css';
import { Mention, MentionBlot } from 'quill-mention';

// Register mention module and blot
Quill.register('modules/mention', Mention);
Quill.register('formats/mention', MentionBlot);

const MentionEditor = ({ member = [], handleChangeMentions, value, clearTrigger }) => {
    const editorRef = useRef(null);
    const quillRef = useRef(null);

    const mentionValues = member.map(user => ({
        id: user.id,
        value: user.display
    }));

    useEffect(() => {
        if (!editorRef.current || quillRef.current || member.length === 0) return;

        quillRef.current = new Quill(editorRef.current, {
            theme: 'snow',
            modules: {
                toolbar: [['bold', 'italic', 'underline']],
                mention: {
                    mentionDenotationChars: ['@'],
                    isolateCharacter: true,
                    renderItem: (item) => {
                        const container = document.createElement('div');
                        container.style.display = 'flex';
                        container.style.alignItems = 'center';
                        container.style.padding = '5px 10px';
                        container.style.height = '50px';
                        container.style.boxSizing = 'border-box';
                        container.style.cursor = 'pointer';

                        const avatarWrapper = document.createElement('div');
                        avatarWrapper.style.width = '30px';
                        avatarWrapper.style.height = '30px';
                        avatarWrapper.style.borderRadius = '50%';
                        avatarWrapper.style.marginRight = '10px';
                        avatarWrapper.style.display = 'flex';
                        avatarWrapper.style.alignItems = 'center';
                        avatarWrapper.style.justifyContent = 'center';
                        avatarWrapper.style.backgroundColor = '#ddd';
                        avatarWrapper.style.color = '#555';
                        avatarWrapper.style.fontWeight = 'bold';
                        avatarWrapper.style.fontSize = '14px';
                        avatarWrapper.style.flexShrink = '0';
                        avatarWrapper.style.overflow = 'hidden';

                        if (item.avatar) {
                            const avatarImg = document.createElement('img');
                            avatarImg.src = item.avatar;
                            avatarImg.alt = item.value;
                            avatarImg.style.width = '100%';
                            avatarImg.style.height = '100%';
                            avatarImg.style.objectFit = 'cover';
                            avatarWrapper.appendChild(avatarImg);
                        } else {
                            const initial = document.createTextNode(item.value.charAt(0).toUpperCase());
                            avatarWrapper.appendChild(initial);
                        }

                        const label = document.createElement('span');
                        label.textContent = item.value;

                        container.appendChild(avatarWrapper);
                        container.appendChild(label);
                        return container;
                    },
                    source: function (searchTerm, renderList) {
                        const matches = mentionValues.filter(item =>
                            item.value.toLowerCase().includes(searchTerm.toLowerCase())
                        );
                        renderList(matches, searchTerm);
                    }
                }
            }
        });



        // ✅ Set initial value
        if (value && typeof value === 'string') {
            quillRef.current.clipboard.dangerouslyPasteHTML(value);
        }

        quillRef.current.on('text-change', () => {
            const html = editorRef.current.querySelector('.ql-editor')?.innerHTML || '';
            const delta = quillRef.current.getContents();
            const mentions = [];
            let plainText = '';

            delta.ops?.forEach(op => {
                if (typeof op.insert === 'string') {
                    plainText += op.insert;
                } else if (op.insert?.mention) {
                    const mention = op.insert.mention;
                    mentions.push(mention.id);
                    plainText += `@${mention.value} `;
                }
            });

            handleChangeMentions(plainText.trim(), html, [...new Set(mentions)]);
        });
    }, [member, value]);

    useEffect(() => {
        if (clearTrigger && quillRef.current) {
            quillRef.current.setText('');
        }
    }, [clearTrigger]);
    // useEffect(() => {
    //     if (!quillRef.current) return;

    //     const currentHTML = editorRef.current.querySelector('.ql-editor')?.innerHTML || '';
    //     const tempDiv = document.createElement('div');
    //     tempDiv.innerHTML = value;

    //     const newContent = tempDiv.innerHTML.trim();
    //     const oldContent = currentHTML.trim();

    //     if (newContent !== oldContent) {
    //         if (!value) {
    //             quillRef.current.setText('');
    //         } else {
    //             quillRef.current.clipboard.dangerouslyPasteHTML(value);
    //         }
    //     }
    // }, [value]);


    return (
        <div style={{ width: '100%', border: "1px solid #e9e5e5", borderRadius: "7px" }}>
            <div ref={editorRef} style={{ width: '100%', height: "150px" }} />
        </div>
    );
};


export default MentionEditor;
